export const LOGO_URL =
  "/ChatGPT%20Image%20Jun%203%2C%202026%2C%2001_36_32%20PM%20%284%29.png";

export const SISTER_BRAND_URL = "https://centralfloridacustomcakes.com/";
export const STUDIO_PARTNER_URL = "https://garcesbrosstudios.com/";
export const BUILDER_PARTNER_URL = "https://buildyoursourcecode.com/";

export const CONTACT_EMAIL = "heritagetablecatering@gmail.com";
export const SERVICE_AREA = "Orlando & all of Central Florida";

export const HERO_DISH_IMAGE = "/traditions/hero-dish.png";

// AI-generated (Nano Banana) gallery images — featured in the "From Our Kitchen" gallery section
export const KITCHEN_GALLERY = [
  { id: "hero-dish", src: "/traditions/hero-dish.png", caption: "signature plate" },
  { id: "latin-caribbean", src: "/traditions/latin-caribbean.png", caption: "abuela's kitchen" },
  { id: "old-world", src: "/traditions/old-world.png", caption: "from the homestead" },
  { id: "african-ethiopian", src: "/traditions/african-ethiopian.png", caption: "shared by hand" },
  { id: "southern-american", src: "/traditions/southern-american.png", caption: "front porch favorites" },
  { id: "biblical-hebraic", src: "/traditions/biblical-hebraic.png", caption: "ancient & meaningful" },
  { id: "dessert", src: "/traditions/dessert.png", caption: "with our sister brand" },
];

export const TRADITIONS = [
  {
    id: "latin-caribbean",
    title: "Latin & Caribbean Table",
    script: "abuela's kitchen",
    description:
      "Cuban, Puerto Rican, Taíno-rooted, and Spanish-influenced family dishes — slow-simmered, deeply seasoned, served with warmth.",
    notes: ["Cuban", "Puerto Rican", "Taíno roots", "Spanish-influenced"],
    accent: "rose",
    image:
      "https://images.unsplash.com/photo-1604908554007-92e1ed94a3a7?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "old-world",
    title: "Old World & European Table",
    script: "from the homestead",
    description:
      "Italian Sunday suppers, English comfort, and Amish & Mennonite-inspired Ohio homestyle meals built on patience and butter.",
    notes: ["Italian", "English", "Amish-inspired", "Mennonite", "Ohio homestyle"],
    accent: "sage",
    image:
      "https://images.unsplash.com/photo-1525351484163-7529414344d8?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "african-ethiopian",
    title: "African & Ethiopian Table",
    script: "shared by hand",
    description:
      "Ethiopian-inspired stews, lentils, vegetables, fragrant spices, and communal breads — meant to be shared at one table.",
    notes: ["Ethiopian-inspired", "Stews", "Lentils", "Spice & herbs", "Communal breads"],
    accent: "gold",
    image:
      "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "southern-american",
    title: "Southern & American Table",
    script: "front porch favorites",
    description:
      "Southern Florida cooking, American classics, family-style platters, and easygoing cookout menus for grilling and chilling.",
    notes: ["Southern Florida", "American classics", "Cookout", "Family-style"],
    accent: "rose",
    image:
      "https://images.unsplash.com/photo-1432139509613-5c4255815697?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "biblical-hebraic",
    title: "Biblical & Hebraic Table",
    script: "ancient & meaningful",
    description:
      "A respectful menu of dishes inspired by Scripture and Hebraic tradition — herbs, figs, dates, olives, lentils, and unleavened bread concepts.",
    notes: ["Hebraic-inspired", "Herbs & figs", "Lentils & dates", "Olive & oil", "Unleavened concepts"],
    accent: "sage",
    image:
      "https://images.unsplash.com/photo-1601000938259-9e92002320b2?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "dessert",
    title: "Dessert Table",
    script: "with our sister brand",
    description:
      "Handcrafted by Central Florida Custom Cakes — wedding cakes, pies, cookies, cupcakes, dessert bars, and dessert tables for every gathering.",
    notes: ["Custom cakes", "Pies", "Cookies & bars", "Cupcakes", "Dessert tables"],
    accent: "gold",
    image:
      "https://images.unsplash.com/photo-1535254973040-607b474cb50d?auto=format&fit=crop&w=900&q=80",
    isSisterBrand: true,
  },
];

export const EVENTS = [
  "Weddings",
  "Church gatherings",
  "Baby showers",
  "Bridal showers",
  "Birthday parties",
  "Family reunions",
  "Holiday meals",
  "Private dinners",
  "Community events",
  "Corporate lunches",
  "Memorial meals",
  "Outdoor cookouts",
  "Dessert tables",
];

export const CUISINE_INTERESTS = [
  "Latin & Caribbean",
  "Italian / Old World",
  "Ethiopian / African-Inspired",
  "Amish / Mennonite / Ohio Homestyle",
  "Southern / American",
  "Grilling / Cookout",
  "Biblical / Hebraic-Inspired",
  "Dessert Table / Custom Cakes",
];

export const EVENT_TYPES = [
  "Wedding",
  "Church gathering",
  "Baby shower",
  "Bridal shower",
  "Birthday party",
  "Family reunion",
  "Holiday meal",
  "Private dinner",
  "Community event",
  "Corporate lunch",
  "Memorial meal",
  "Outdoor cookout",
  "Dessert table",
  "Other",
];

export const BUDGETS = [
  "Under $500",
  "$500 – $1,000",
  "$1,000 – $2,500",
  "$2,500 – $5,000",
  "$5,000 – $10,000",
  "$10,000+",
];

export const FAQS = [
  {
    q: "Do you offer custom menus?",
    a: "Yes. Heritage Table Catering can help shape a menu around your event, family traditions, guest count, and preferred food style.",
  },
  {
    q: "Do you provide desserts and cakes?",
    a: "Yes. Desserts and custom cakes can be added through our sister brand, Central Florida Custom Cakes.",
  },
  {
    q: "What kinds of events do you serve?",
    a: "We serve weddings, church gatherings, family celebrations, showers, private dinners, community events, holiday meals, and outdoor gatherings.",
  },
  {
    q: "Do you offer multicultural catering?",
    a: "Yes. Our menu direction includes Latin, Caribbean, Italian, Ethiopian-inspired, Amish and Mennonite-style, Southern, American, Biblical, and Hebraic-inspired dishes.",
  },
  {
    q: "Do you serve all of Central Florida?",
    a: "Yes — we serve all of Orlando and Central Florida. Final availability depends on event location, date, guest count, and scope.",
  },
];
